import request from '@/utils/request'
// 获取图片素材列表
export function qiniuToken() {
  return request({
    url: '/qiniu/token',
    method: 'get'
  })
}
